import { IconDiamond } from '@tabler/icons-react';
import { useMemo } from 'react';
import { Bell, ClipboardList, Documents, Logout3, PhoneCallingRounded, QuestionCircle, UserId } from 'solar-icons';
import { useShadUser } from '@/Module/Auth/Hook';
import { LINKS } from '@/Module/Core/Constant';
import type { IBurgerMenu } from '@/Module/DefaultLayout/Model';
import { HamburgerItems, HamburgerMenuCategory } from '@/Module/DefaultLayout/Model';
import { IconDocumentSolar } from '@/Module/Icon';
import { useAppSelector } from '@/Module/Store/Hook';
export const usePrepareBurgerMenuData = (): IBurgerMenu[] => {
  const isLoggedIn = useAppSelector(state => state.auth.isLoggedIn);
  const isShadUser = useShadUser();
  return useMemo(() => {
    const result: IBurgerMenu[] = [{
      categoryId: HamburgerMenuCategory.INO,
      categoryName: 'آی‌نو',
      children: [{
        itemId: HamburgerItems.INO,
        itemName: 'آی‌نو من',
        icon: <UserId height={16} width={16} />,
        link: LINKS.PROFILE.DEFAULT
      }, {
        itemId: HamburgerItems.COURSES,
        itemName: 'درس‌ها',
        icon: <IconDocumentSolar size="smaller" />,
        link: LINKS.GRADE
      }, {
        itemId: HamburgerItems.TEACHERS,
        itemName: 'معلم‌ها',
        icon: <UserId height={16} width={16} />,
        link: LINKS.TEACHER_LIST
      }, {
        itemId: HamburgerItems.BLOG,
        itemName: 'روزنامه‌دیواری',
        icon: <Documents height={16} width={16} />,
        link: LINKS.BLOG
      }, {
        itemId: HamburgerItems.NOTIFICATION,
        itemName: 'اطلاع رسانی',
        icon: <Bell height={16} width={16} />,
        link: LINKS.BLOG
      }, {
        itemId: HamburgerItems.SUBSCRIPTION,
        itemName: 'اشتراک‌های من',
        icon: <IconDiamond height={16} width={16} />,
        link: LINKS.PROFILE.SUBSCRIPTION
      }]
    }, {
      categoryId: HamburgerMenuCategory.PUBLIC,
      categoryName: 'عمومی',
      children: [{
        itemId: HamburgerItems.FAQ,
        itemName: 'سوالات متداول',
        icon: <QuestionCircle height={16} width={16} />,
        link: LINKS.QUESTION
      }, {
        itemId: HamburgerItems.POLICY,
        itemName: 'قوانین و مقررات',
        icon: <ClipboardList height={16} width={16} />,
        link: LINKS.RULES
      }, {
        itemId: HamburgerItems.CONTACTUS,
        itemName: 'تماس با ما',
        icon: <PhoneCallingRounded height={16} width={16} />,
        link: LINKS.CONTACT_US
      }]
    }];
    if (!isLoggedIn || isShadUser) return result;
    result.push({
      categoryId: HamburgerMenuCategory.EXIT,
      categoryName: 'خروج',
      children: [{
        itemId: HamburgerItems.EXIT,
        itemName: 'خروج از حساب کاربری',
        icon: <Logout3 color="#EB3E31" width={16} height={16} />,
        link: LINKS.AUTH.LOGOUT
      }]
    });
    return result;
  }, [isLoggedIn, isShadUser]);
};